import { render } from "./message.vue?vue&type=template&id=7141562f&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=7141562f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7141562f"

export default script